import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import BoardOfDirectors from "./components/BoardOfDirectors";
import Subsidiaries from "./components/Subsidiaries";
import Footer from "./components/Footer";
import ContactUs from "./components/ContactUs";
import { FaArrowUp } from "react-icons/fa";

const scrollToSection = (sectionId: string) => {
  setTimeout(() => {
    const section = document.getElementById(sectionId);
    if (section) {
      const offset = 80;
      const sectionPosition = section.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: sectionPosition, behavior: "smooth" });
    }
  }, 100);
};

const ScrollToSectionOnLoad: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const sectionId = location.hash.replace("#", "");
    if (sectionId) {
      scrollToSection(sectionId);
    }
  }, [location.hash]);

  return null;
};

const ScrollToTopButton: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    isVisible && (
      <button
        className="scroll-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <FaArrowUp />
      </button>
    )
  );
};

const HomePage: React.FC = () => (
  <>
    <Navbar scrollToSection={scrollToSection} />
    <div id="hero">
      <Hero />
    </div>
    <div id="about">
      <About />
    </div>
    <div id="board-ofdirectors">
      <BoardOfDirectors />
    </div>
    <div id="subsidiaries">
      <Subsidiaries />
    </div>
    <Footer />
    <ScrollToTopButton />
  </>
);

const ContactUsPage: React.FC = () => {
  useEffect(() => {
    scrollToSection("contact");
  }, []);

  return (
    <>
      <Navbar scrollToSection={scrollToSection} />
      <div id="contact">
        <ContactUs />
      </div>
      <Footer />
    </>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToSectionOnLoad />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/contact" element={<ContactUsPage />} />
      </Routes>
    </Router>
  );
};

export default App;